import React, { PropsWithChildren } from "react";

const LoaderBackdrop: React.FC<PropsWithChildren<{}>> = ({ children }) => {
    return (
        <div
            className="absolute inset-0 z-10 flex items-center justify-center bg-background/70 backdrop-blur-[2px]"
            aria-hidden={false}
        >
            {children}
        </div>
    );
};

export default LoaderBackdrop;
